























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { StatisticsUpdated, StatisticsUpdatedEventName } from '@/app/statistics/events/section-interaction-events';
import { TocItem } from '@/app/shared/models';
import {
  SectionProgressInterface,
  SectionProgressSymbol,
  SectionCompletion
} from '@/app/statistics/section/section-progress';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import { tocHrefEqualsPage, tocHrefPagesEquals } from '@/app/aspect/toc-utils';
import ProgressCircleComponent from '@/app/sidebar-navigation/components/progress-circle-component.vue';
import aspectStoreModule from '@/app/aspect/apsect-state';

@Component({
  name: 'SidebarNavigationItemComponent',
  components: {
    SidebarNavigationItemComponent, ProgressCircleComponent
  }
})
export default class SidebarNavigationItemComponent extends Vue {
  @Prop()
  public tocItem: TocItem;

  public open: boolean = false;
  public listenerId: string|null = null;

  public currentSectionCompletion: SectionCompletion|null = null;
  public currentSectionCompletionLoaded: boolean = false;

  private currentTimeout: number|null = null;

  private percentsBySectionId: { [sectionId: string]: number } = {};

  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  @lazyInject(SectionProgressSymbol)
  private sectionProgressService: SectionProgressInterface;

  public get currentPage(): string {
    return this.$route.params.page;
  }

  private get selectedChapter(): TocItem|null {
    return aspectStoreModule.selectedChapter;
  }

  public async mounted(): Promise<void> {
    if (this.tocItem.children) {
      this.openIfNecessary(this.tocItem);
    }

    this.queryPercentsAndListenInteractions();

    this.scrollToSelectedItem();

    this.currentSectionCompletion = this.sectionProgressService.find(this.tocItem.id);

    this.currentSectionCompletionLoaded = true;
  }

  public destroyed(): void {
    if (this.listenerId !== null) {
      this.eventStream.removeListener(StatisticsUpdatedEventName, this.listenerId);
    }
  }

  public tocHrefEqualsPage(href: string|null): boolean {
    return tocHrefEqualsPage(this.currentPage, href);
  }

  public getPageLocationByHref(href: string) {
    return getPageLocationByHref(href);
  }

  public getPageLocationForSubTocItem(subTocItem: TocItem, href: string) {
    const location = getPageLocationByHref(href);
    if (!location.query.section
        && this.currentSectionCompletion !== null
        && tocHrefPagesEquals(subTocItem.href, this.tocItem.href)) {
      location.query.section = subTocItem.id;
    }

    return location;
  }

  /*public getPercent(tocItem: TocItem, isChild: boolean = false) {
    // TODO: listen instead
    if (isChild && tocItem.href === this.tocItem.href) {
      const completion = this.sectionProgressService.find(tocItem.id);
      if (completion === null) {
        return 0;
      }

      return completion.progress.completion;
    }

    return Math.round(sectionProgressState.progressBySectionId[tocItem.id]);
  }*/

  @Watch('selectedChapter')
  public onSelectedChapterChanged(newValue: TocItem): void {
    this.queryPercentsAndListenInteractions();
    this.open = false;
  }

  @Watch('currentPage')
  public onCurrentPageChanged() {
    this.openIfNecessary(this.tocItem);

    this.scrollToSelectedItem();
  }

  private queryPercentsAndListenInteractions() {
    const sectionIds: string[] = this.getSectionIds();
    this.percentsBySectionId = this.queryInitialPercents(sectionIds);
    this.listenSectionInteractionSaved(sectionIds);
  }

  private getSectionIds(): string[] {
    let sectionIds: string[] = [this.tocItem.id];
    if (this.tocItem.children) {
      this.tocItem.children.forEach((c) => sectionIds = [...sectionIds, c.id]);
    }

    return sectionIds;
  }

  private queryInitialPercents(sectionIds: string[]): { [sectionId: string]: number } {
    const result: { [sectionId: string]: number } = {};
    sectionIds.forEach((sectionId) => {
      const completion = this.sectionProgressService.find(sectionId);
      result[sectionId] = completion !== null ? Math.round(completion.progress.completion) : 0;
    });

    return result;
  }

  private listenSectionInteractionSaved(sectionIds: string[]): void {
    this.listenerId = this.eventStream.listen(StatisticsUpdatedEventName, (payload: StatisticsUpdated) => {
      const completion: SectionCompletion = payload.completion;
      if (sectionIds.includes(completion.sectionId)) {
        this.percentsBySectionId[completion.sectionId] = Math.round(completion.progress.completion);
      }
    });
  }

  private openIfNecessary(tocItem: TocItem): void {
    if (!tocItem.children) {
      return;
    }

    for (const child of tocItem.children) {
      if (tocHrefEqualsPage(this.currentPage, child.href)) {
        this.open = true;
        return;
      }

      this.openIfNecessary(child);
      if (this.open) {
        return;
      }
    }
  }

  private scrollToSelectedItem(): void {
    if (this.currentTimeout !== null) {
      clearTimeout(this.currentTimeout);
    }

    if (!this.pageExistsInTocItem(this.tocItem)) {
      return;
    }

    this.currentTimeout = setTimeout(() => {
      const $scrollElement: any = $('.menu-list-wrapper');

      let href: string = this.currentPage;
      if (this.$route.query.section) {
        href = `${href}?section=${this.$route.query.section}`;
      }
      const $item: any = $(`.menu-list-wrapper #menu [href$="${href}"]`).closest('.sidebar-caption');

      if ($item) {
        $scrollElement.animate({
          scrollTop: !$item.offset() ? 0 : $item.offset().top + $scrollElement.scrollTop() - $scrollElement.offset().top
        }, 300);
      }
    }, 200);
  }

  private pageExistsInTocItem(tocItem: TocItem): boolean {
    if (tocHrefEqualsPage(this.currentPage, tocItem.href)) {
      return true;
    }

    if (!tocItem.children) {
      return false;
    }

    for (const child of tocItem.children) {
      const exists: boolean = this.pageExistsInTocItem(child);
      if (exists) {
        return true;
      }
    }

    return false;
  }
}
